import { render } from "./ImageLightbox.vue?vue&type=template&id=0e4f7030&scoped=true"
import script from "./ImageLightbox.vue?vue&type=script&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=0e4f7030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4f7030"]])

export default __exports__